'use strict';

angular.module('atex.dam').factory('DamCompareModal',
    ['$rootScope', '$q', '$modal', '$sce', '$timeout', '$compile', '$filter',
      'Application', 'ApplicationConfigurationService', 'AuthenticationService',
      'DamService', 'DamNotificationService', 'ContentService', 'configuration', '$translate',
  function($rootScope, $q, $modal, $sce, $timeout, $compile, $filter,
               Application, ApplicationConfigurationService, AuthenticationService,
               DamService, DamNotificationService, ContentService, configuration, $translate) {
    var showCompare = function (props) {
      var openNoteU = 9862;
      var closedNoteU = 9863;
      var closeParaU = 9865;
      var brU = 9864;

      var swapped = true;
      var lhs;
      var rhs;

      var dmp;
      var DIFF_NONE = -2;
      var DIFF_DELETE = -1;
      var DIFF_INSERT = 1;
      var DIFF_EQUAL = 0;

      var dateTimeFormat = 'yyyy-MM-dd HH:mm:ss';
      var element;
      var compareResultsUnbindHandler;
      var storageName = 'dam.compare.settings.' + Application.currentUser.principalId;
      var modalScope = $rootScope.$new(true);
      var deferred = $q.defer();

      _.extend(modalScope, props);

      window.atex = window.atex || {};

      if (configuration.getDateTimeFormat()) {
        dateTimeFormat = configuration.getDateTimeFormat();
      }

      function destroyModal() {
        modal.then(function (modalEl) {
          modalEl.on('hidden.bs.modal', function () {
            modalScope.$destroy();
          });

          modalEl.modal('hide');
        });
      }

      function loadSettings() {
        var settings = {
          sides: [{}, {}],
          sideBySide: false,
          elementLink: false,
          channelLink: false,
          versionLink: false,
          showChanges: true
        };

        if (typeof localStorage[storageName] !== 'undefined') {
          settings = JSON.parse(localStorage[storageName]);
        }

        return settings;
      }

      function saveSettings(settings) {
        localStorage[storageName] = JSON.stringify(settings);
      }

      function getPrintAttributes(entry) {
        return atex.onecms.ObjectUtils.getByPath(entry, '_data/aspects/atex.ChannelContentData/data/channels/Print/elements');
      }

      function getContentData(entry) {
        var path = '_data/aspects/contentData/data';

        return atex.onecms.ObjectUtils.getByPath(entry, path);
      }

      function decodeHtml(html) {
        var txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
      }

      function parseHtml(htmlString) {
        var doc = document.implementation.createHTMLDocument("");
        doc.body.innerHTML = htmlString;

        return doc;
      }

      function createElement(name) {
        return document.createElement(name);
      }

      function expandNotes(text, notes) {
        function replaceNoteAnchor(noteAnchor) {
          function createNoteSpan(note) {
            var span = createElement('span');
            span.className = "x-atex-note";
            span.setAttribute("x-atex-user", note.user);
            span.setAttribute("x-atex-created", note.created);
            span.setAttribute("x-atex-modified", note.modified);
            span.innerHTML = note.text;

            return span;
          }

          var id = noteAnchor.text;

          if (typeof id !== 'undefined' && typeof notes[id] !== 'undefined') {
            var parent = noteAnchor.parentNode;
            parent.replaceChild(createNoteSpan(notes[id]), noteAnchor);
          }
        }

        var doc = parseHtml(text);
        var noteAnchors = doc.querySelectorAll('script[type="text/atex-note"]');

        for (var i = 0; i < noteAnchors.length; ++i) {
          replaceNoteAnchor(noteAnchors[i]);
        }

        return doc.body.innerHTML;
      }

      function isNote(element) {
        return element.hasClass('x-atex-note');
      }

      function isCollapsed(element) {
        return element.hasAttribute('x-atex-note-cid');
      }

      function encodeNote(note, noteU) {
        var encodedNote = note.replace(/./g, function (c) {
          return String.fromCharCode(noteU);
        });

        return encodedNote;
      }

      function encodeNotes(html) {
        var notesDoc = parseHtml(html);

        var noteSpans = notesDoc.querySelectorAll('span.x-atex-note');

        noteSpans.forEach(function (noteSpan) {
          if (isCollapsed(noteSpan)) {
            // Collapsed Note
            noteSpan.innerText = encodeNote(noteSpan.innerText, closedNoteU);

          } else {
            //expanded Note
            noteSpan.innerText = encodeNote(noteSpan.innerText, openNoteU);
          }
        });

        return notesDoc.body.innerHTML;
      }

      function decodeNotes(html) {
        var doc = parseHtml(html);


        return doc.body.innerHTML;
      }

      function encodeParas(html) {
        var parasDoc = parseHtml(html);

        parasDoc.querySelectorAll('p').forEach(function (noteSpan) {
          noteSpan.innerText = noteSpan.innerText + String.fromCharCode(closeParaU);
        });

        return String(parasDoc.body.innerHTML).replace(/<br\s*[\/]*>/gm, String.fromCharCode(brU));
      }

      function htmlToPlaintext(text) {
        return text ? String(text).replace(/<[^>]+>/gm, '') : '';
      }

      function getPlainText(html, encode) {
        var encodedHtml = encode ? encodeNotes(html) : html;

        encodedHtml = encodeParas(encodedHtml);

        var obj = htmlToPlaintext(encodedHtml);

        obj = obj.trim();
        obj = obj.replace(/\r?\n|\r/g, "");

        return decodeHtml(obj);
      }

      function processDiffText(html, op, text, notes, notesOffset) {
        var run = '';
        var inNote = false;
        var noteState = false;
        var noteCh = '';
        var ch = '';

        for (var i = 0; i < text.length; ++i) {
          ch = text.charCodeAt(i);

          if (ch === closeParaU) {
            pushText(html, op, inNote, run);
            html.push("</p>");
            html.push("<p>");
            run = '';
          } else {
            if (notes) {
              noteCh = notes.charCodeAt(notesOffset + i);
            }

            noteState = noteCh === openNoteU;

            if (noteState !== inNote) {
              pushText(html, op, inNote, run);
              inNote = noteState;
              run = '';
            }

            if (ch === brU) {
              run += '<br>';
            } else {
              run += String.fromCharCode(ch);
            }
          }
        }

        pushText(html, op, inNote, run);
      }

      function pushText(html, op, inNote, text) {
        if (text === '') {
          return;
        }

        var anotatedText = '<span class="';

        switch (op) {
          case DIFF_INSERT:
            anotatedText += 'dmp-insert';
            break;
          case DIFF_DELETE:
            anotatedText += 'dmp-delete';
            break;
          case DIFF_EQUAL:
            anotatedText += 'dmp-equal';
            break;
        }

        if (inNote) {
          anotatedText += '-note';
        }

        anotatedText += '">' + text + '</span>';

        html.push(anotatedText);
      }


      function LoadCompareHtml(diffs, opFilter, notes, otherNotes, notesOnly) {
        var html = [];
        var pattern_amp = /&/g;
        var pattern_lt = /</g;
        var pattern_gt = />/g;
        var pattern_para = /\n/g;
        var notesOffset = 0;
        var otherOffset = 0;

        html.push("<p>");

        for (var x = 0; x < diffs.length; x++) {
          var op = diffs[x][0];    // Operation (insert, delete, equal)

          if (opFilter !== DIFF_NONE && op !== DIFF_EQUAL && op !== opFilter) {
            continue;
          }

          var data = diffs[x][1];  // Text of change.
          var text = data.replace(pattern_amp, '&amp;').replace(pattern_lt, '&lt;')
            .replace(pattern_gt, '&gt;').replace(pattern_para, '&para;<br>');

          if (otherNotes) {
            switch (op) {
              case DIFF_INSERT:
                processDiffText(html, op, text, notes, notesOffset);
                notesOffset += text.length;
                break;
              case DIFF_DELETE:
                processDiffText(html, op, text, otherNotes, otherOffset);
                otherOffset += text.length;
                break;
              case DIFF_EQUAL:
                processDiffText(html, op, text, notes, notesOffset);
                notesOffset += text.length;
                otherOffset += text.length;
                break;
            }

          } else {
            processDiffText(html, notesOnly ? DIFF_EQUAL : op, text, notes, notesOffset, otherNotes, otherOffset);
            notesOffset += text.length;
          }
        }

        return html.join('');
      }

      function UpdateCompareHtml(id, htmlDiff) {
        var $htmlArea = $(element.find('div[entry-id="' + id + '"]')[0]);

        $htmlArea.html('').append($compile(htmlDiff)(modalScope));
      }

      function getSideCompareHtml(side) {
        if (!side || !side.version) {
          return '';
        }

        return getContent(side.version.entry, side.attribute, side.variant.name, true);
      }

      function getSideContent(side) {
        if (!side || !side.version) {
          return '';
        }

        return getContent(side.version.entry, side.attribute, side.variant.name);
      }

      function getSideController(side) {
        if (!side || !side.version) {
          return '';
        }

        return getAttributeController(side.version.entry, side.attribute, side.variant.name);
      }

      function getAttributeController(entry, attribute, channel) {
        var printAttribute;
        var printAttributes = getPrintAttributes(entry);

        if (printAttributes) {
          printAttributes.forEach(function (pAttribute, index) {
            if (channel === 'Print') {
              if (pAttribute.attributeName === attribute) {
                printAttribute = pAttribute;
              }
            } else {
              if (pAttribute.attribute === attribute &&
                pAttribute.channel === channel) {
                printAttribute = pAttribute;
              }
            }
          });
        }

        return printAttribute;
      }

      function getPrintAttribute(entry, attribute, channel) {
        var printAttribute;
        var printAttributes = getPrintAttributes(entry);

        printAttribute = getAttributeController(entry, attribute, channel);

        if (printAttribute && channel === 'Web') {
          if (!printAttribute.hasContent) {
            printAttribute = undefined;
          }
        }

        return printAttribute;
      }

      function getContentDataAttribute(entry, attribute) {
        var contentDataAttribute;
        var contentData = getContentData(entry);

        if (contentData) {
          contentDataAttribute = contentData[attribute];

          return contentDataAttribute;
        }
      }

      function getContentDataText(entry, attribute, processNotes) {
        var content;
        var contentDataAttribute = getContentDataAttribute(entry, attribute);

        if (contentDataAttribute) {
          //if ( contentDataAttribute._type === 'com.atex.plugins.structured.text.StructuredText') {
          if (contentDataAttribute.text) {
            if (processNotes) {
              var txt = atex.dam.AngularUtils.copyNoHash(contentDataAttribute.text);

              if (contentDataAttribute.notes) {
                var notes = atex.dam.AngularUtils.copyNoHash(contentDataAttribute.notes);

                var expanded = expandNotes(txt, notes);

                content = atex.dam.AngularUtils.copyNoHash(expanded);
              } else {
                content = contentDataAttribute.text;
              }
            }
            else {
              content = contentDataAttribute.text;
            }
          }

          if (!content) {
            content = contentDataAttribute;
          }
        }

        if (!content) {
          content = "";
        }

        return content;
      }

      function getContent(entry, attribute, channel, processNotes) {
        var content;

        var printAttribute = getPrintAttribute(entry, attribute, channel);

        if (printAttribute) {
          content = printAttribute.content;
        } else {
          content = getContentDataText(entry, attribute, processNotes);
        }

        return content;
      }

      function isSideCurrent(side) {
        return (side && side.version && side.version.current);
      }

      function hasDiffs(diffs) {
        return (diffs && !diffsAreEqual(diffs));
      }

      function diffsAreEqual(diffs) {
        var areEqual = true;

        diffs.forEach(function (diff) {
          if (diff[0] !== DIFF_EQUAL) {
            areEqual = false;
          }
        });

        return areEqual;
      }

      function createVersion(versionNo, entry) {
        var versionInfo = _.extend({}, entry.versionInfo);

        versionInfo.entry = entry;
        versionInfo.versionNo = versionNo;
        versionInfo.formattedDate = $filter('date')(versionInfo.creationTime, dateTimeFormat);
        versionInfo.masterDiffs = false;
        versionInfo.versionDiffs = false;
        versionInfo.sideDiffs = false;
        versionInfo.current = false;

        return versionInfo;
      }

      function calculateMasterEntries(list) {
        var currentEntry;
        var masterList = [];
        var first = true;

        //var masterList = list.slice();
        list.forEach(function (entry, entryIndex) {
          currentEntry = createVersion(entryIndex + 1, entry); // pick up first entry
          if (first) {
            first = false;
            currentEntry.current = true;
          }
          masterList.push(currentEntry);
        });

        return masterList;
      }

      function calculateSideVersions(side, otherSide) {
        var versions = [];
        var currentVersion;
        var first = true;

        modalScope.masterVersions.forEach(function (version, index) {
          currentVersion = createVersion(index + 1, version.entry); // pick up first entry
          if (first) {
            first = false;
            currentVersion.current = true;
          }

          versions.push(currentVersion);
        });

        currentVersion = undefined;
        var currentSideVersion;

        versions.forEach(function (version, index) {
          if (currentVersion) {
            var baseHtml = getContent(currentVersion.entry, side.attribute, side.variant.name, true);
            var compareHtml = getContent(version.entry, side.attribute, side.variant.name, true);

            var changes = sidesHaveDiffs(baseHtml, compareHtml);

            version.versionDiffs = changes;

            if (changes) {
              currentVersion = version;
            }

            if (otherSide) {
              baseHtml = getContent(currentSideVersion.entry, otherSide.attribute, otherSide.variant.name, true);
              compareHtml = getContent(version.entry, otherSide.attribute, otherSide.variant.name, true);

              changes = sidesHaveDiffs(baseHtml, compareHtml);

              version.sideDiffs = changes;

              if (changes) {
                currentSideVersion = version;
              }
            }
          } else {
            currentVersion = version; // pick up first entry
            currentSideVersion = version;
          }
        });

        return versions;
      }

      function calculateElementList(side, otherSide) {
        var versions = [];

        modalScope.compareConfig.config.fields.forEach(function (field, fieldIndex) {
          var version = createVersion(side.version.versionNo, side.version.entry); // pick up first entry
          var otherVersion = createVersion(otherSide.version.versionNo, otherSide.version.entry); // pick up first entry

          var versionContent = getContent(version.entry, field, side.variant.name, true);
          var otherVersionContent = getContent(otherVersion.entry, field, otherSide.variant.name, true);

          version.sideDiffs = sidesHaveDiffs(versionContent, otherVersionContent);
          version.field = field;

          versions.push(version);

        });

        return versions;
      }

      function calculateChannelList(side, otherSide) {
        var versions = [];

        modalScope.compareConfig.config.variants.forEach(function (variant, variantIndex) {
          var version = createVersion(side.version.versionNo, side.version.entry); // pick up first entry
          var otherVersion = createVersion(otherSide.version.versionNo, otherSide.version.entry); // pick up first entry

          var versionContent = getContent(version.entry, side.attribute, variant.name, true);
          var otherVersionContent = getContent(otherVersion.entry, otherSide.attribute, variant.name, true);

          version.sideDiffs = sidesHaveDiffs(versionContent, otherVersionContent);
          version.variant = variant;

          versions.push(version);
        });

        return versions;
      }

      function getMakeCurrentDesc(sideKey) {
        var currentSide = modalScope.sides[sideKey === 0 ? 1 : 0];
        var sourceSide = modalScope.sides[sideKey];

        return '<div>' + $translate.getTranslationTable().__COMPARE_REPLACE__ + ' <b>' + modalScope.getDesc(currentSide) +
          '</b></div><div> ' + $translate.getTranslationTable().__REPLACE_WITH__ + ' <b>' + modalScope.getDesc(sourceSide) + '</b></div>';
      }

      function isSelected(version) {
        var selectedIndex = modalScope.selected.findIndex(function (entry) {
          return entry.versionInfo.creationTime === version.entry.versionInfo.creationTime;
        });

        return selectedIndex >= 0;
      }

      function getVersionIndex(versions, entry) {
        return versions.findIndex(function (version) {
          return version.creationTime === entry.versionInfo.creationTime;
        });
      }

      function versionsSame(lhsVersion, rhsVersion) {
        if (lhsVersion && rhsVersion) {
          return lhsVersion.creationTime === rhsVersion.creationTime;
        }

        return false;
      }

      function calculateVersionLists(resetSideVersion) {
        modalScope.querying = true;

        $timeout(function () {
          var leftVersions = calculateSideVersions(modalScope.sides[0], modalScope.sides[1]);
          var rightVersions = calculateSideVersions(modalScope.sides[1], modalScope.sides[0]);

          modalScope.sides[0].variants = modalScope.getVariants(modalScope.sides[0].attribute);
          modalScope.sides[1].variants = modalScope.getVariants(modalScope.sides[1].attribute);

          // Eliminate ones without any changes or not current.
          leftVersions.forEach(function (leftVersion, index) {
            var rightVersion = rightVersions[index];
            var keep = false;

            if (leftVersion.current || leftVersion.sideDiffs || leftVersion.versionDiffs) {
              keep = true;
            }

            if (isSelected(leftVersion) || versionsSame(leftVersion, modalScope.sides[0].version)) {
              keep = true;
            }

            if (rightVersion.current || rightVersion.sideDiffs || rightVersion.versionDiffs || isSelected(leftVersion)) {
              keep = true;
            }

            if (isSelected(rightVersion) || versionsSame(rightVersion, modalScope.sides[1].version)) {
              keep = true;
            }

            leftVersion.keep = keep;
            rightVersion.keep = keep;
          });

          modalScope.sides[0].versions = _.filter(leftVersions, function (version) {
            return (version.keep);
          });
          modalScope.sides[1].versions = _.filter(rightVersions, function (version) {
            return (version.keep);
          });

          if (resetSideVersion) {
            var noSelected = _.size(modalScope.selected);
            var rhsIndex = 0;
            var lhsIndex = -1;

            if (noSelected > 0) {
              if (noSelected === 2) {
                lhsIndex = getVersionIndex(modalScope.sides[0].versions, modalScope.selected[1]);
              }
              rhsIndex = getVersionIndex(modalScope.sides[0].versions, modalScope.selected[0]);
            }

            if (lhsIndex === -1) {
              lhsIndex = rhsIndex + 1;

              if (lhsIndex >= _.size(modalScope.sides[0].versions)) {
                lhsIndex = rhsIndex;
              }
            }

            // We have two versions get the newest on the right
            if (modalScope.sides[0].versions[lhsIndex].creationTime > modalScope.sides[0].versions[rhsIndex].creationTime) {
              var tIndex = lhsIndex;
              lhsIndex = rhsIndex;
              rhsIndex = tIndex;
            }

            console.log("lhsIndex = ", lhsIndex);
            console.log("rhsIndex = ", rhsIndex);
            console.log("swapped = ", swapped);

            console.log("lhs = ", lhs);
            console.log("rhs = ", rhs);

            //if ( !swapped ) {
            //  var tIndex = lhsIndex;
            //  lhsIndex = rhsIndex;
            //  rhsIndex = tIndex;
            //}

            modalScope.sides[lhs].version = modalScope.sides[0].versions[lhsIndex];
            modalScope.sides[rhs].version = modalScope.sides[0].versions[rhsIndex];
          }

          modalScope.sides[0].elementVersions = calculateElementList(modalScope.sides[0], modalScope.sides[1]);
          modalScope.sides[1].elementVersions = calculateElementList(modalScope.sides[1], modalScope.sides[0]);

          modalScope.sides[0].channelVersions = calculateChannelList(modalScope.sides[0], modalScope.sides[1]);
          modalScope.sides[1].channelVersions = calculateChannelList(modalScope.sides[1], modalScope.sides[0]);

          modalScope.sides[0].makeCurrentDesc = getMakeCurrentDesc(0);
          modalScope.sides[1].makeCurrentDesc = getMakeCurrentDesc(1);

          loadDiff();

          modalScope.querying = false;
        });
      }

      function sidesHaveDiffs(baseHtml, compareHtml) {
        var baseContent = getPlainText(baseHtml);
        var baseNotes = getPlainText(baseHtml, true);

        var compareContent = getPlainText(compareHtml);
        var compareNotes = getPlainText(compareHtml, true);

        var diffs = diffContent(baseContent, compareContent);

        if (hasDiffs(diffs)) {
          return true;
        }

        diffs = diffContent(baseNotes, compareNotes);

        return hasDiffs(diffs);
      }

      function diffContent(baseContent, compareContent) {
        var diffs = dmp.diff_main(baseContent, compareContent);

        dmp.diff_cleanupSemantic(diffs);

        return diffs;
      }

      function loadDiff() {
        var baseHtml = getSideCompareHtml(modalScope.sides[lhs]);
        var baseContent = getPlainText(baseHtml);
        var baseNotes = getPlainText(baseHtml, true);

        var compareHtml = getSideCompareHtml(modalScope.sides[rhs]);
        var compareContent = getPlainText(compareHtml);
        var compareNotes = getPlainText(compareHtml, true);

        // The compare dialog opens with the newest version on the right.
        // If for some reason the user has decided to switch them over then we have to change the display operation.
        // As far as I can see that's only really relevant if it's versions of the same story element.
        var leftOp = DIFF_DELETE;
        var rightOp = DIFF_INSERT;

        /*
         if ( (prRightData.m_lItemId == prLeftData.m_lItemId) && (prRightData.m_lStoryId == prLeftData.m_lStoryId)
         && (prRightData.m_nVersion != 0) )
         {
         if ( (prLeftData.m_nVersion == 0) || ( prLeftData.m_nVersion > prRightData.m_nVersion) )
         {
         // Swap over the way we display results and the base and compare strings
         nLeftOperation = DIFF_INSERT;
         nRightOperation = DIFF_DELETE;

         prwstring strTemp = strBaseData;
         strBaseData = strCompareData;
         strCompareData = strTemp;
         }
         }
         */

        var diffs = diffContent(baseContent, compareContent);

        if (diffs) {

          if (swapped) {
            UpdateCompareHtml('consolidated', LoadCompareHtml(diffs, DIFF_NONE, compareNotes, baseNotes));
            UpdateCompareHtml('rhs', LoadCompareHtml(diffs, leftOp, baseNotes));
            UpdateCompareHtml('lhs', LoadCompareHtml(diffs, rightOp, compareNotes));
            UpdateCompareHtml('rhs-notes', LoadCompareHtml(diffs, leftOp, baseNotes, undefined, true));
            UpdateCompareHtml('lhs-notes', LoadCompareHtml(diffs, rightOp, compareNotes, undefined, true));
          } else {
            UpdateCompareHtml('consolidated', LoadCompareHtml(diffs, DIFF_NONE, compareNotes, baseNotes));
            UpdateCompareHtml('lhs', LoadCompareHtml(diffs, leftOp, baseNotes));
            UpdateCompareHtml('rhs', LoadCompareHtml(diffs, rightOp, compareNotes));
            UpdateCompareHtml('lhs-notes', LoadCompareHtml(diffs, leftOp, baseNotes, undefined, true));
            UpdateCompareHtml('rhs-notes', LoadCompareHtml(diffs, rightOp, compareNotes, undefined, true));
          }
        }
      }

      function createSide() {
        var side = {
          attribute: modalScope.attribute,
          element: undefined,
          variant: undefined,
          version: undefined,
          entry: undefined,
          variants: [],
          versions: [],
          makeCurrentDesc: '',
          elementVersions: [],
          channelVersions: []
        };

        if (modalScope.channel) {
          side.channel = modalScope.channel;
          side.variant = modalScope.getVariant(modalScope.attribute, modalScope.channel, false);
          side.element = modalScope.getElementLabel(modalScope.attribute);
          side.variants = modalScope.getVariants(modalScope.attribute);
        }

        return side;
      }

      function initialiseScope() {
        modalScope.querying = true;
        modalScope.elementLink = true;
        modalScope.channelLink = false;
        modalScope.versionLink = false;
        modalScope.showChanges = true;

        modalScope.settings = loadSettings();
        modalScope.sideBySide = modalScope.settings.sideBySide;

        if (typeof modalScope.settings.elementLink !== 'undefined') {
          modalScope.elementLink = modalScope.settings.elementLink;
        }

        if (typeof modalScope.settings.channelLink !== 'undefined') {
          modalScope.channelLink = modalScope.settings.channelLink;
        }

        if (typeof modalScope.settings.versionLink !== 'undefined') {
          modalScope.versionLink = modalScope.settings.versionLink;
        }

        if (typeof modalScope.settings.showChanges !== 'undefined') {
          modalScope.showChanges = modalScope.settings.showChanges;
        }


        modalScope.genericVariant = {channel: "Neutral", icon: "fa fa-code-fork", default: false, domainObject: "web"};

        var compareConfig;

        if (modalScope.compareBinding) {
          compareConfig = atex.dam.AngularUtils.copyNoHash(modalScope.compareBinding);
        } else {
          compareConfig = {
            name: "channels",
            label: "Channels",
            refresh: false,

            domainObjects: {
              print: "atex.PrintVariants",
              web: "contentData"
            },

            config: {
              currentLeft: true,
              fields: ["headline", "lead", "body"],
              labels: {headline: {alias: "_HEADLINE_"}, lead: {alias: "_LEAD_LABEL_"}, body: {alias: "_BODY_"}},
              variants: [
                {channel: "Web", icon: "fa fa-globe", default: false, domainObject: "web"},
                {channel: "Print", icon: "fa fa-newspaper-o", default: true, domainObject: "print"}]
            }
          };
        }

        _.each(compareConfig.config.variants, function (variant, index, list) {
          variant.name = variant.channel;
        });

        _.each(compareConfig.config.labels, function (value, key, list) {
          value.variants = compareConfig.config.variants;
        });

        if (typeof compareConfig !== 'undefined' && typeof compareConfig.config !== 'undefined' &&
          typeof compareConfig.config.currentLeft !== 'undefined') {
          swapped = compareConfig.config.currentLeft;
        }

        modalScope.compareConfig = compareConfig;

        lhs = swapped ? 1 : 0;
        rhs = swapped ? 0 : 1;

        dmp = new diff_match_patch();  // jshint ignore:line
        dmp.Diff_Timeout = 1;
        dmp.Diff_EditCost = 4;
      }

      function getLatestPrintVariants() {
        modalScope.querying = false; // move to completion when querying server
      }

      function initModal() {
        modalScope.sides = [];

        // iniaialse attribute and channel to first in config.
        modalScope.attribute = modalScope.compareConfig.config.fields[0];
        modalScope.channel = modalScope.compareConfig.config.variants[0].channel;

        modalScope.sides.push(createSide());
        modalScope.sides.push(createSide());

        calculateVersionLists(true);
      }

      var loadContentHistory = function () {
        getLatestPrintVariants();

        modalScope.masterVersions = calculateMasterEntries(modalScope.entries);

        initModal();
      };

      modalScope.getDesc = function (side) {
        if (!side || !side.version) {
          return '';
        }

        var desc = modalScope.getContentName(side) + ' - ' +
          $translate.getTranslationTable()[modalScope.getElementLabel(side.attribute)] + ' - ' + side.channel +
          ' - ' + side.version.creatorName + ' - ' +
          side.version.formattedDate;

        return desc;

      };

      modalScope.getContentName = function (side) {
        if (!side || !side.version) {
          return '';
        }

        return getContentDataText(side.version.entry, 'name');
      };

      modalScope.getText = function (side) {
        return getPlainText(getSideCompareHtml(side));
      };

      modalScope.getVariant = function (attribute, channel, generic) {
        var variant;
        var label = modalScope.compareConfig.config.labels[attribute];

        if (label) {
          variant = _.find(label.variants, function (v) {
            return v.name === channel;
          });
        }

        if (!variant && generic) {
          variant = modalScope.genericVariant;
        }

        return variant;
      };

      modalScope.getVariants = function (element) {
        var variants = [];
        var label = modalScope.compareConfig.config.labels[element];

        if (label && label.variants) {
          variants = label.variants;
        }

        return variants;
      };

      modalScope.getElementLabel = function (element) {
        var label = modalScope.compareConfig.config.labels[element];

        if (label && label.alias) {
          return label.alias;
        }

        return element;
      };

      modalScope.setElementLink = function () {
        modalScope.elementLink = !modalScope.elementLink;
        modalScope.settings.elementLink = modalScope.elementLink;
        saveSettings(modalScope.settings);
      };

      modalScope.setChannelLink = function () {
        modalScope.channelLink = !modalScope.channelLink;
        modalScope.settings.channelLink = modalScope.channelLink;
        saveSettings(modalScope.settings);
      };

      modalScope.setVersionLink = function () {
        modalScope.versionLink = !modalScope.versionLink;
        modalScope.settings.versionLink = modalScope.versionLink;
        saveSettings(modalScope.settings);
      };

      modalScope.setElement = function (sideIndex, field) {
        modalScope.sides[sideIndex].attribute = field;
        modalScope.settings.sides[sideIndex].attribute = field;

        if (modalScope.elementLink) {
          var otherSide = sideIndex === 0 ? 1 : 0;

          modalScope.sides[otherSide].attribute = field;
          modalScope.settings.sides[otherSide].attribute = field;
        }

        saveSettings(modalScope.settings);

        calculateVersionLists();
      };

      modalScope.setVariant = function (sideIndex, variant) {
        modalScope.sides[sideIndex].variant = variant;
        modalScope.sides[sideIndex].channel = variant.name;
        modalScope.settings.sides[sideIndex].channel = variant.name;

        if (modalScope.channelLink) {
          var otherSide = sideIndex === 0 ? 1 : 0;

          modalScope.sides[otherSide].variant = variant;
          modalScope.sides[otherSide].channel = variant.name;
          modalScope.settings.sides[otherSide].channel = variant.name;
        }

        saveSettings(modalScope.settings);

        calculateVersionLists();
      };

      modalScope.setVersion = function (sideIndex, version) {
        modalScope.sides[sideIndex].version = version;

        if (modalScope.versionLink) {
          var otherSide = sideIndex === 0 ? 1 : 0;

          modalScope.sides[otherSide].version = version;
        }

        calculateVersionLists();
      };

      modalScope.changeShowChanges = function () {
        modalScope.settings.showChanges = modalScope.showChanges;

        saveSettings(modalScope.settings);
        loadDiff();
      };

      modalScope.changeSideBySide = function () {
        modalScope.settings.sideBySide = modalScope.sideBySide;

        saveSettings(modalScope.settings);
        loadDiff();
      };

      initialiseScope();

      loadContentHistory();

      var modal = $modal({
        show: true,
        scope: modalScope,

        template: 'views/dam-compare-modal.html',
        modalClass: 'compare-modal ng-cloak',
        backdrop: 'static',
        keyboard: false
      });

      modalScope.canMakeCurrent = function (sideKey) {
        if (!modalScope.usePrintServer) {
          var currentSide = modalScope.sides[sideKey === 0 ? 1 : 0];
          var otherSide = modalScope.sides[sideKey];

          if (!(currentSide && currentSide.version && currentSide.version.entry)) {
            return false;
          }

          if (!(otherSide && otherSide.version && otherSide.version.entry)) {
            return false;
          }
        }

        if (isSideCurrent(modalScope.sides[0]) && isSideCurrent(modalScope.sides[1])) {
          return false;
        }

        var otherSideKey = sideKey === 0 ? 1 : 0;

        return !isSideCurrent(modalScope.sides[sideKey]) && isSideCurrent(modalScope.sides[otherSideKey]);
      };

      modalScope.makeCurrent = function (sideKey) {
        function onMakeCurrent(update, item, message) {
          if (typeof modalScope.onMakeCurrent === 'function') {
            modalScope.onMakeCurrent(update, item, message);
          }

          modalScope.doOk();
        }

        var currentSide = modalScope.sides[sideKey === 0 ? 1 : 0];
        var otherSide = modalScope.sides[sideKey];

        if (!(currentSide && currentSide.version && currentSide.version.entry)) {
          return;
        }

        if (!(otherSide && otherSide.version && otherSide.version.entry)) {
          return;
        }

        var currentEntry = currentSide.version.entry;
        var otherEntry = otherSide.version.entry;

        var currentAttribute = getPrintAttribute(currentEntry, currentSide.attribute, currentSide.variant.channel);
        var otherAttribute = getPrintAttribute(otherEntry, otherSide.attribute, otherSide.variant.channel);

        var item = atex.dam.AngularUtils.copyNoHash(currentEntry);

        item.revision = currentEntry.revision;
        atex.dam.AngularUtils.sanitizeContentData(item._data.aspects.contentData);
        delete(item._data.lockData);

        var updateContentData = false;

        if (!currentAttribute) {
          // Current is not Print
          if (!otherAttribute) {
            // Other is not a print variant
            var currentContentData = getContentData(item);
            var otherContentData = getContentData(otherEntry);

            currentContentData[currentSide.attribute + '_type'] = atex.dam.AngularUtils.copyNoHash(otherContentData[otherSide.attribute + '_type']);
            currentContentData[currentSide.attribute] = atex.dam.AngularUtils.copyNoHash(otherContentData[otherSide.attribute]);

            updateContentData = true;
          }
        }

        if (updateContentData) {
          ContentService.updateContent({
            id: item.id,
            revision: item.revision,
            data: item._data
          }).then(function (response) {
            onMakeCurrent(true, item, '');
          }).then(null, function (error) {
            var message = error.cause;
            onMakeCurrent(false, item, error.cause);
          });
        } else {
          // Here we check if we have current and other print attribute and call the new restore service
          if (currentAttribute && otherAttribute) {
            modalScope.sending = true;
            var versionToRestoreFrom = otherSide.version.version;
            DamService.restorePrintContent(versionToRestoreFrom, otherAttribute.elementName).then(function(resp) {
              modalScope.sending = false;
              modalScope.doOk();
            }).then(null, function(error) {
              var message = error.cause || 'Error restoring version';
              DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: message }), true);
              modalScope.sending = false;
            });
          } else {
            modalScope.doOk();
          }
        }
      };

      modalScope.doneClicked = function () {
        modalScope.doOk();
      };

      modalScope.cancelClicked = function () {
        modalScope.doCancel();
      };

      modalScope.doCancel = function () {
        destroyModal();
        deferred.resolve(false);
      };

      modalScope.doOk = function () {
        destroyModal();
        deferred.resolve(true);
      };

      compareResultsUnbindHandler = modalScope.$on('copyfit:compareResults', function (event, shapes, selectedShape, selectedServerFilter) {
        //modalScope.selectedShape = selectedShape;
        //modalScope.shapeData = shapes;

        //rebuildShapes(modalScope.shapeData);

        //modalScope.selectedServerFilter = selectedServerFilter;
      });

      modal.then(function (modalElement) {
        element = modalElement;

        element.on('hidden.bs.modal', function () {
          if (typeof compareResultsUnbindHandler !== 'undefined') {
            compareResultsUnbindHandler();
            compareResultsUnbindHandler = undefined;
          }
        });

      });

      return deferred.promise;
    };

    // The returned object will be an instance of this service.
    return {
      showCompare: showCompare
    };
  }]);